import {
  CcfTranslationKey,
  useTranslator,
} from '../ccf-translator/ccf-translator';
import FormControlLabel from '@mui/material/FormControlLabel';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import Switch from '@mui/material/Switch';

interface SettingsSwitchItemProps {
  handleChange: (
    event: React.SyntheticEvent<Element, Event>,
    checked: boolean
  ) => void;
  hideLessThanExtraLarge?: boolean;
  icon?: JSX.Element;
  id?: string;
  isChecked?: boolean;
  isDisabled?: boolean;
  name: string;
  text: CcfTranslationKey;
  listStyles?: any;
  labelStyles?: any;
}

/**
 *
 * @param param0 - switch parms
 * @example CcfSettingsSwitchItem()
 * @returns
 */
export const CcfSwitchItem = ({
  handleChange,
  hideLessThanExtraLarge,
  icon,
  id,
  isChecked,
  isDisabled,
  name,
  text,
  listStyles,
  labelStyles,
}: SettingsSwitchItemProps) => {
  const [translate] = useTranslator();

  return (
    <ListItem 
      sx={{
        display: {
          xs: hideLessThanExtraLarge ? 'none' : 'list-item',
          sm: hideLessThanExtraLarge ? 'none' : 'list-item',
          md: hideLessThanExtraLarge ? 'none' : 'list-item',
          lg: 'flex',
          
        },
        listStyle :'none',
      }}
      style = {listStyles}
      id={id}>
      { icon && <ListItemIcon sx={{ display: { xs: 'none', sm: 'inline' } }}>
        {icon}
      </ListItemIcon>
      }
      <FormControlLabel
        control={<Switch checked={isChecked} disabled={isDisabled} />}
        disabled={isDisabled}
        label={translate(text)}
        labelPlacement="start"
        name={name}
        onChange={handleChange}
        sx={{
          ' .MuiFormControlLabel-label': {
            width: 165,
          },
        }}
        style = {labelStyles}
      />
    </ListItem>
  );
};

export default CcfSwitchItem;
